// EditStudent Component for update student data 

// Import Modules 
import React, { useState, useEffect } from "react";
import { useParams, useNavigate,useOutletContext } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PatientHistoryForm from "../Forms/PatientHistoryForm";
import CONFIG from '../../config';
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";


// EditStudent Component 
const EditPatientHistory = () => {
  const {patientData, setPatientData, selectedCase, doctorInfo} = usePatient();
  const { patientId, caseId, visitId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { markSectionComplete } = useOutletContext() ;  
  const { verifyTokenAndRedirect } = useAuth();
  const  location  = useLocation();

    
  useEffect(()=>{

    verifyTokenAndRedirect();

  }, []);




  //onSubmit handler 
  const onSubmitHandler = (updatedHistory) => {

 
 console.log("patient data after submit:", updatedHistory); // Log the data to be updated

//  const updatedData = {
//   ...patientData, 
//   patientHistory: [{ ...updatedHistory }] // Overwrite patientInfo while keeping other data unchanged
// };

// const updatedData = {
//   ...patientData, 
//   patientHistory: patientData.patientHistory.map(info => ({
//       ...info, // Keep existing patientInfo fields
//       ...updatedHistory // Merge updated fields
//   }))
// };

// const updatedData = {
//   ...patientData,
//   patientHistory: patientData.patientHistory.length > 0 
//       ? patientData.patientHistory.map(info => ({
//           ...info, // Keep existing patientInfo fields
//           ...updatedHistory // Merge updated fields
//       }))
//       : [updatedHistory] // If empty, create a new array with updatedHistory
// };

const updatedData = {
  ...patientData,
  patientHistory: patientData?.patientHistory?.length > 0 
      ? patientData.patientHistory.map(info => ({
          ...info, // Keep existing patientInfo fields
          ...updatedHistory, // Merge updated fields
          PATIENT_ID: patientData.PATIENT_ID,
          CASE_ID: selectedCase || caseId, // Add CASE_ID if missing
//          VISIT_ID: selectedVisit || visitId  // Add VISIT_ID if missing
DOCTOR_ID: doctorInfo.MANDALI_ID,
CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields

}))
      : [{
          ...updatedHistory,
          PATIENT_ID: patientData.PATIENT_ID, 
          CASE_ID: selectedCase || caseId,  // Default CASE_ID if not provided
//          VISIT_ID: selectedVisit || visitId // Default VISIT_ID if not provided
DOCTOR_ID: doctorInfo.MANDALI_ID,
CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields

}]
};


setPatientData(updatedData);
markSectionComplete("history");
if (location.pathname.startsWith("/addpatient")) {
 navigate("/addpatient/ci");
} else if (location.pathname.startsWith("/visits")) {
 navigate(`/visits/${patientId}/${caseId}/${visitId}/ci`);
} else {
 console.warn("Unknown route, no redirection");
}

   };


  // Return student form 
  return (

    <div>
      {console.log('inside rendering: ', patientData)}
      {patientData || (patientId === undefined && caseId === undefined && visitId === undefined) ? (
        <PatientHistoryForm
          initialValues={{...patientData, patientHistory: patientData?.patientHistory || [{}],}}
          onSubmit={onSubmitHandler}
          enableReinitialize={true}
        >
          Update Patient
        </PatientHistoryForm>
      ):(
        <h3>Loading ...</h3>
      )}
    </div>
  );

};

export default EditPatientHistory;

